/* Items mobile swipers - Deferred initialization to prevent forced reflows */

document.addEventListener('DOMContentLoaded', function() {
    // Defer Swiper initialization until after initial paint to prevent forced reflows
    requestAnimationFrame(function() {
        // Steps Banner Mobile Slider
        const stepsBannerEl = document.querySelector('.steps-banner-mobile-swiper');
        if (stepsBannerEl) {
            const stepsBannerSwiper = new Swiper(stepsBannerEl, {
                slidesPerView: 1.2,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: '.steps-banner-mobile-swiper .swiper-pagination',
                    clickable: true
                }
            });
        }

        // Four Info Banners Mobile Slider
        const fourInfoBannersEl = document.querySelector('.four-info-banners-mobile-swiper');
        if (fourInfoBannersEl) {
            const fourInfoBannersSwiper = new Swiper(fourInfoBannersEl, {
                slidesPerView: 1.2,
                spaceBetween: 12,
                loop: false,
                pagination: {
                    el: '.four-info-banners-mobile-swiper .swiper-pagination',
                    clickable: true
                }
            });
        }

        // Transfer Types Banners Mobile Slider
        const transferTypesBannersEl = document.querySelector('.transfer-types-banners-mobile-swiper');
        if (transferTypesBannersEl) {
            const transferTypesBannersSwiper = new Swiper(transferTypesBannersEl, {
                slidesPerView: 1.2,
                spaceBetween: 16,
                loop: false,
                navigation: {
                    nextEl: '.transfer-types-banners-mobile-swiper .swiper-button-next',
                    prevEl: '.transfer-types-banners-mobile-swiper .swiper-button-prev',
                }
            });
        }

        // Options for Every Budget Mobile Slider
        const optionsForEveryBudgetEl = document.querySelector('.options-for-every-budget-block .options-swiper');
        if (optionsForEveryBudgetEl) {
            const optionsSwiper = new Swiper(optionsForEveryBudgetEl, {
                slidesPerView: 'auto',
                spaceBetween: 12,
                loop: false,
                grabCursor: true,
                touchRatio: 1,
                simulateTouch: true,
                allowTouchMove: true,
                freeMode: true
            });
        }


        // General mobile swipers
        var mobileSwipers = document.querySelectorAll(".mobile-swiper-carousel .swiper:not(.steps-banner-mobile-swiper, .four-info-banners-mobile-swiper, .options-swiper)");

        mobileSwipers.forEach(function(container) {
            if (container) {
                new Swiper(container, {
                    slidesPerView: 2.5,
                    spaceBetween: 16,
                    loop: false,

                    navigation: {
                        nextEl: container.querySelector(".swiper-button-next"),
                        prevEl: container.querySelector(".swiper-button-prev"),
                    },

                    breakpoints: {
                        0: {
                            slidesPerView: 1.5,
                        },

                        520: {
                            slidesPerView: 2.5,
                        },
                    },
                });
            }
        });
    });
});

// /* /Items mobile swipers  */
// document.addEventListener('DOMContentLoaded', function() {
//     // Select all anchor tags with the class 'open-new-tab' that are NOT in the main navigation
//     let menuItems = document.querySelectorAll('a.open-new-tab:not(#primary-menu-list a)');

//     menuItems.forEach(function(item) {
//         item.addEventListener('click', function(event) {
//             console.log('clicked');
//             event.preventDefault();
//             window.open(item.href, '_blank');
//         });
//     });
// });






/* 6 items desktop swiper - Deferred initialization */

document.addEventListener('DOMContentLoaded', function() {
    requestAnimationFrame(function() {
        var grid_6_swipers = document.querySelectorAll(".grid-6-swiper .swiper");

        grid_6_swipers.forEach(function(container) {
            if (container) {
                new Swiper(container, {
                    slidesPerView: 6,
                    spaceBetween: 24,
                    loop: false,

                    navigation: {
                        nextEl: container.querySelector(".swiper-button-next"),
                        prevEl: container.querySelector(".swiper-button-prev"),
                    },

                    breakpoints: {
                        0: {
                            slidesPerView: 1.5,
                            spaceBetween: 16,
                        },

                        420: {
                            slidesPerView: 2.5,
                            spaceBetween: 16,
                        },

                        520: {
                            slidesPerView: 3.5,
                            spaceBetween: 16,
                        },

                        769: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },

                        900: {
                            slidesPerView: 5,
                        },

                        1200: {
                            slidesPerView: 6,
                        },
                    },
                });
            }
        });
    });
});

/* /6 items desktop swiper */

/* Design-25 Airport Routes Swiper — nav lives in the .d25-city-header above the swiper */
document.addEventListener('DOMContentLoaded', function() {
    requestAnimationFrame(function() {
        var d25RouteSwipers = document.querySelectorAll('.d25-airport-routes-swiper .swiper');

        d25RouteSwipers.forEach(function(container) {
            if (!container) return;

            var cityBlock = container.closest('.city');
            var prevBtn   = cityBlock ? cityBlock.querySelector('.d25-slider-nav .swiper-button-prev') : null;
            var nextBtn   = cityBlock ? cityBlock.querySelector('.d25-slider-nav .swiper-button-next') : null;

            new Swiper(container, {
                slidesPerView: 5,
                spaceBetween: 16,
                loop: false,
                watchOverflow: true,

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },

                breakpoints: {
                    0:    { slidesPerView: 1.15, spaceBetween: 12 },
                    520:  { slidesPerView: 2.5, spaceBetween: 12 },
                    769:  { slidesPerView: 3,   spaceBetween: 16 },
                    992:  { slidesPerView: 4,   spaceBetween: 16 },
                    1200: { slidesPerView: 5,   spaceBetween: 16 },
                },
            });
        });
    });
});
/* /Design-25 Airport Routes Swiper */

/* Design-25 Popular Routes Simple Swiper — nav lives in the .d25-city-header above the swiper */
document.addEventListener('DOMContentLoaded', function() {
    requestAnimationFrame(function() {
        var d25PopularSwipers = document.querySelectorAll('.most-popular-routes .d25-popular-routes-swiper .swiper');

        d25PopularSwipers.forEach(function(container) {
            if (!container) return;

            var block   = container.closest('.most-popular-routes');
            var prevBtn = block ? block.querySelector('.d25-slider-nav .swiper-button-prev') : null;
            var nextBtn = block ? block.querySelector('.d25-slider-nav .swiper-button-next') : null;

            new Swiper(container, {
                slidesPerView: 5,
                spaceBetween: 16,
                loop: false,
                watchOverflow: true,

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },

                breakpoints: {
                    0:    { slidesPerView: 1.15, spaceBetween: 12 },
                    520:  { slidesPerView: 2.5,  spaceBetween: 12 },
                    769:  { slidesPerView: 3,    spaceBetween: 16 },
                    992:  { slidesPerView: 4,    spaceBetween: 16 },
                    1200: { slidesPerView: 5,    spaceBetween: 16 },
                },
            });
        });
    });
});
/* /Design-25 Popular Routes Simple Swiper */

/* Design-25 Popular Airports Simple Swiper — nav lives in the .d25-city-header above the swiper */
document.addEventListener('DOMContentLoaded', function() {
    requestAnimationFrame(function() {
        var d25AirportSwipers = document.querySelectorAll('.popular-airports-simple .d25-popular-airports-swiper .swiper');

        d25AirportSwipers.forEach(function(container) {
            if (!container) return;

            var block   = container.closest('.popular-airports-simple');
            var prevBtn = block ? block.querySelector('.d25-slider-nav .swiper-button-prev') : null;
            var nextBtn = block ? block.querySelector('.d25-slider-nav .swiper-button-next') : null;

            new Swiper(container, {
                slidesPerView: 6,
                spaceBetween: 16,
                loop: false,
                watchOverflow: true,

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },

                breakpoints: {
                    0:    { slidesPerView: 1.5, spaceBetween: 12 },
                    769:  { slidesPerView: 4,   spaceBetween: 16 },
                    900:  { slidesPerView: 5,   spaceBetween: 16 },
                    1200: { slidesPerView: 6,   spaceBetween: 16 },
                },
            });
        });
    });
});
/* /Design-25 Popular Airports Simple Swiper */

/* Design-25 Quickest Routes Tabs Swiper — nav lives in the .d25-city-header of each tab pane */
document.addEventListener('DOMContentLoaded', function() {
    requestAnimationFrame(function() {
        var d25QuickestSwipers = document.querySelectorAll('.routes-tabs.d25 .d25-quickest-routes-swiper .swiper');

        d25QuickestSwipers.forEach(function(container) {
            if (!container) return;

            var pane    = container.closest('.tab-pane');
            var prevBtn = pane ? pane.querySelector('.d25-slider-nav .swiper-button-prev') : null;
            var nextBtn = pane ? pane.querySelector('.d25-slider-nav .swiper-button-next') : null;

            new Swiper(container, {
                slidesPerView: 5,
                spaceBetween: 16,
                loop: false,
                watchOverflow: true,

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },

                breakpoints: {
                    0:    { slidesPerView: 1.15, spaceBetween: 12 },
                    520:  { slidesPerView: 2.5,  spaceBetween: 12 },
                    769:  { slidesPerView: 3,    spaceBetween: 16 },
                    992:  { slidesPerView: 4,    spaceBetween: 16 },
                    1200: { slidesPerView: 5,    spaceBetween: 16 },
                },
            });
        });
    });
});
/* /Design-25 Quickest Routes Tabs Swiper */

/* 4 items desktop swiper - Deferred initialization */

document.addEventListener('DOMContentLoaded', function() {
    requestAnimationFrame(function() {
        var grid_4_swipers = document.querySelectorAll(".grid-4-swiper .swiper");

        grid_4_swipers.forEach(function(container) {
            if (container) {
                new Swiper(container, {
                    slidesPerView: 4,
                    spaceBetween: 24,
                    loop: false,

                    navigation: {
                        nextEl: container.querySelector(".swiper-button-next"),
                        prevEl: container.querySelector(".swiper-button-prev"),
                    },

                    breakpoints: {
                        0: {
                            slidesPerView: 1.5,
                            spaceBetween: 16,
                        },

                        520: {
                            slidesPerView: 2.5,
                            spaceBetween: 16,
                        },

                        769: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },

                        992: {
                            slidesPerView: 4,
                        },
                    },
                });
            }
        });
    });
});

/* /4 items desktop swiper */

/* Tabs */

var tabs = document.querySelectorAll(".tabs");

tabs.forEach(function(tab) {
    let tabButton = tab.querySelectorAll(".tab-button");
    let tabContents = tab.querySelectorAll(".tab-pane");

    tabButton.forEach(function(button) {
        button.addEventListener("click", function() {
            tabButton.forEach(function(button) {
                button.classList.remove("active");
            });

            tabContents.forEach(function(content) {
                content.classList.remove("show");
            });

            button.classList.add("active");

            // Get the tab content
            let targetTab = button.getAttribute("data-target-tab");
            let tabContent = tab.querySelector("." + targetTab);

            // Add show class to the active tab content
            if (tabContent) {
                tabContent.classList.add("show");
            }
        });
    });
});

// Mobile dropdown

var navTabs = document.querySelectorAll(".tabs .nav-tabs .holder .mobile-toggle-overlay");

navTabs.forEach(function(tab) {
    tab.addEventListener("click", function(event) {
        // Prevent the event from bubbling up to the document
        event.stopPropagation();

        // Add the class "opened" to the clicked tab
        tab.closest('.holder').classList.add("opened");
    });
});

document.addEventListener("click", function(event) {
    navTabs.forEach(function(tab) {
        // If the click is outside of any .tabs .nav-tabs element, remove the "opened" class
        if (!tab.contains(event.target)) {
            tab.closest('.holder').classList.remove("opened");
        }
    });
});

// Closes the dropdown when the user clicks button

var tabButtons = document.querySelectorAll('.tab-button');


tabButtons.forEach(button => {
    button.addEventListener('click', function() {
        var holder = button.closest('.holder');

        // Remove the 'opened' class if it exists
        if (holder && holder.classList.contains('opened')) {
            holder.classList.remove('opened');
        }
    });
});

/* /Tabs */

/* Accordion show / hide | For FAQ*/

document.addEventListener('DOMContentLoaded', function() {
    var accordionItemButton = document.querySelectorAll('.accordion-button');
    
    accordionItemButton.forEach(button => {
        button.addEventListener('click', function() {
            const accordionItem = this.closest('.accordion-item');
            accordionItem.classList.toggle('show');
        });
    });
});

/* /FAQ show / hide */

/* All Airports Covered by Alps2Alps: Mobile airport toggle */

function setupAirportToggles() {
    var airportToggles = document.querySelectorAll('.all-airports .item .name');

    // Remove any existing click event listeners to avoid duplication
    airportToggles.forEach(function(airportToggle) {
        airportToggle.removeEventListener('click', handleAirportToggle);
    });

    if (window.innerWidth < 769) {
        airportToggles.forEach(function(airportToggle) {
            airportToggle.addEventListener('click', handleAirportToggle);
        });
    }
}

function handleAirportToggle(event) {
    this.closest('.item').classList.toggle('mobile-show');
}

// Initial setup
setupAirportToggles();

// Setup event listener for window resize
window.addEventListener('resize', setupAirportToggles);

/* /All Airports Covered by Alps2Alps: Mobile airport toggle */

/* All Airports (design-25): Mobile country tabs */

function setupAirportCountryTabs() {
    var blocks = document.querySelectorAll('.all-airports-d25-mobile');

    blocks.forEach(function(block) {
        var tabs = block.querySelectorAll('.airport-country-tab');

        tabs.forEach(function(tab) {
            tab.addEventListener('click', function() {
                var country = this.getAttribute('data-country');

                block.querySelectorAll('.airport-country-tab').forEach(function(t) {
                    t.classList.remove('is-active');
                });
                block.querySelectorAll('.airport-country-panel').forEach(function(p) {
                    p.classList.remove('is-active');
                });

                this.classList.add('is-active');

                var panel = block.querySelector('.airport-country-panel[data-country="' + country + '"]');
                if (panel) {
                    panel.classList.add('is-active');
                }
            });
        });
    });
}

setupAirportCountryTabs();

/* /All Airports (design-25): Mobile country tabs */

// Newsletter form submit - moved to inline script in newsletter-block.php (sends to n8n webhook)

function rotateSubtitles() {
    const subtitles = document.querySelectorAll('.header-subtitle.partner-subtitle span');

    // Check if subtitles exist before proceeding
    if (subtitles.length === 0) {
        return; // Exit the function if no subtitles are found
    }

    let currentIndex = 0;

    function fadeOut(el) {
        el.style.transition = 'opacity 0.5s';
        el.style.opacity = 0;
        setTimeout(() => {
            el.style.display = 'none';
            fadeIn(subtitles[(currentIndex + 1) % subtitles.length]);
            currentIndex = (currentIndex + 1) % subtitles.length;
        }, 500); // Match this time with the transition duration
    }

    function fadeIn(el) {
        el.style.display = 'block';
        el.style.opacity = 0;
        el.style.transition = 'opacity 0.5s';
        setTimeout(() => {
            el.style.opacity = 1;
        }, 10); // Small delay to ensure transition happens
    }

    // Start with the first subtitle displayed
    subtitles.forEach((span, index) => {
        if (index !== 0) {
            span.style.display = 'none';
            span.style.opacity = 0;
        } else {
            span.style.display = 'block';
            span.style.opacity = 1;
        }
    });

    // Run the subtitle rotation every 3 seconds (adjust time as needed)
    setInterval(() => {
        fadeOut(subtitles[currentIndex]);
    }, 5000); // 3-second interval before fading to the next subtitle
}

// Call the function on page load
rotateSubtitles();

const contactFormAnchor = document.querySelector('a[href="#b2b-contact-form-anchor"]');
if (contactFormAnchor) { // Check if the element exists
    contactFormAnchor.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default anchor behavior
        const target = document.querySelector('#b2b-contact-form-anchor');
        
        // Calculate the position to scroll, adjusting for the middle of the screen
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - (window.innerHeight / 2) + (target.clientHeight / 2);
        
        // Smooth scrolling to the calculated position
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const swiperWrapper = document.querySelector('.last-minute-hero .swiper-wrapper');
    if (swiperWrapper) {
        const slides = swiperWrapper.querySelectorAll('.swiper-slide');

        slides.forEach(slide => {
            const form = slide.querySelector('.booking-form form');
            if (!form) return;

            const quantityInput = form.querySelector('.quantity-input');
            const minusButton = form.querySelector('.quantity-minus');
            const plusButton = form.querySelector('.quantity-plus');

            if (!quantityInput || !minusButton || !plusButton) return;

            // Minus button
            minusButton.addEventListener('click', function(e) {
                e.preventDefault();
                let currentValue = parseInt(quantityInput.value) || 1;
                if (currentValue > 1) {
                    quantityInput.value = currentValue - 1;
                }
            });

            // Plus button
            plusButton.addEventListener('click', function(e) {
                e.preventDefault();
                let currentValue = parseInt(quantityInput.value) || 1;
                const max = parseInt(quantityInput.getAttribute('max')) || 100;
                if (currentValue < max) {
                    quantityInput.value = currentValue + 1;
                }
            });

            // Manual input validation
            quantityInput.addEventListener('input', function() {
                const max = parseInt(this.getAttribute('max')) || 100;
                let rawValue = parseFloat(this.value);
                
                if (isNaN(rawValue)) {
                    rawValue = 1;
                }
                
                // Force whole number and ensure minimum of 1
                let newValue = Math.floor(rawValue);
                if (newValue < 1) {
                    newValue = 1;
                }
                if (newValue > max) {
                    newValue = max;
                }
                
                this.value = newValue;
            });
        });
    }
});

// Book Now button logic
jQuery(document).ready(function($) {
    $(document).on('click', '.last-minute-hero .book-now:not(.blocked-button)', function(e) {
        e.preventDefault();

        const $button = $(this);
        const $form = $button.closest('form');
        const baseLink = $button.data('link');
        const passengers = parseInt($form.find('.quantity-input').val()) || 1;
        const $card = $button.closest('.offer-card');
        const offerId = $card.attr('data-last-minute-offer-id');

        if (!offerId || !baseLink) {
            console.error('Missing offer ID or link');
            return;
        }

        // Make an AJAX GET request to check the offer details
        $.get(`${apiBaseUrl}/api/offers/${offerId}`, function(response) {
            if (passengers <= response.seats) {
                // Create a form element to submit
                const form = $('<form>', {
                    'action': baseLink,
                    'method': 'POST'
                });

                // Add hidden input for pax
                form.append($('<input>', {
                    'type': 'hidden',
                    'name': 'pax',
                    'value': passengers
                }));

                // Append the form to the body and submit it
                $('body').append(form);
                form.submit();
            } else {
                // Handle case when seats are no longer available
                const lang = document.documentElement.lang || 'en';
                
                const reservedText = {
                    "en": "Reserved for Now",
                    "fr": "Réservé pour l'instant",
                    "tr": "Şu an için rezerve",
                    "ru": "Зарезервировано на данный момент",
                    "pt": "Reservado por agora",
                    "es": "Reservado por ahora"
                };

                const buttonText = reservedText[lang] || reservedText["en"];

                // Update button state
                $button.text(buttonText);
                $button.addClass('blocked-button');
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            console.error('[A2A-DEBUG] Book now failed');
            console.error('[A2A-DEBUG] Status:', textStatus);
            console.error('[A2A-DEBUG] Error:', errorThrown);
            console.error('[A2A-DEBUG] Response:', jqXHR.responseText);
        });
    });
});


window.addEventListener('message', function(event) {
    // For security, verify the origin
    if (event.origin.includes('alps2alps.com') !== true) return;
    
    if (event.data.type === 'scrollIframeToTop') {
      var targetOffset = event.data.targetOffset || 120;
      
      // Find the iframe (you might need to adjust the selector)
      var iframe = document.querySelector('iframe');
      
      if (iframe) {
        var iframeRect = iframe.getBoundingClientRect();
        var currentPositionFromTop = iframeRect.top;
        
        // Only scroll if iframe is currently more than targetOffset px from top
        if (currentPositionFromTop > targetOffset) {
          var iframeTop = iframeRect.top + window.pageYOffset;
          var targetScroll = iframeTop - targetOffset;
          
          // Smooth scroll to position
          window.scrollTo({
            top: targetScroll,
            behavior: 'smooth'
          });
        }
      }
    }
});

// Resorts Slider (Modern Design) - Initialize on window load to ensure Swiper is available
window.addEventListener('load', function() {
    if (typeof Swiper === 'undefined') return;
    
    var resortsSliderContainers = document.querySelectorAll('.resorts-slider.all-resorts-by-country--modern, .resorts-slider.top-ski-resorts--modern, .resorts-slider.blog-posts-d25');
    resortsSliderContainers.forEach(function(container) {
        var swiperEl = container.querySelector('.resorts-swiper');
        if (!swiperEl) return;
        
        var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
        var isMobile = window.innerWidth < 992;
        var shouldEnableSwiper = isMobile || slideCount > 4;
        
        var prevBtn = container.querySelector('.resorts-slider-prev');
        var nextBtn = container.querySelector('.resorts-slider-next');
        
        if (shouldEnableSwiper) {
            // Add class to enable swiper mode in CSS
            container.classList.add('swiper-enabled');
            
            var swiperInstance = new Swiper(swiperEl, {
                slidesPerView: 'auto',
                spaceBetween: 16,
                loop: false,
                grabCursor: true,
                touchRatio: 1,
                simulateTouch: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 'auto',
                        spaceBetween: 12,
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    }
                },
                on: {
                    init: function() {
                        // Show navigation arrows once Swiper is initialized
                        if (prevBtn) prevBtn.classList.add('show-nav');
                        if (nextBtn) nextBtn.classList.add('show-nav');
                    }
                }
            });
        } else {
            // Hide navigation when swiper is disabled (4 or fewer items on desktop)
            var nav = container.querySelector('.resorts-slider-nav');
            if (nav) nav.style.display = 'none';
        }
    });
});

// Design-25 "text left" Resorts/Airports slider — 2 cards per view, no arrows or bullets
window.addEventListener('load', function() {
    if (typeof Swiper === 'undefined') return;

    var textLeftSwipers = document.querySelectorAll('.resorts-slider-d25-text-left .d25-tl-swiper');

    textLeftSwipers.forEach(function(swiperEl) {
        var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

        // Fractional views below 768px keep part of the next card in sight so the
        // row always overflows and stays swipeable; a lone card fills the row.
        var breakpoints = {
            0:   { slidesPerView: 1.15, spaceBetween: 12 },
            480: { slidesPerView: 1.6,  spaceBetween: 12 },
            768: { slidesPerView: 2,    spaceBetween: 16 }
        };

        if (slideCount < 2) {
            breakpoints = { 0: { slidesPerView: 1, spaceBetween: 0 } };
        }

        new Swiper(swiperEl, {
            slidesPerView: 2,
            spaceBetween: 16,
            loop: false,
            watchOverflow: true,
            grabCursor: true,
            allowTouchMove: true,

            breakpoints: breakpoints
        });
    });
});

// Design-25 "blue panel" Resorts/Airports slider — 4 cards per view, no arrows or bullets
window.addEventListener('load', function() {
    if (typeof Swiper === 'undefined') return;

    var panelSwipers = document.querySelectorAll('.resorts-slider-d25-panel .d25-panel-swiper');

    panelSwipers.forEach(function(swiperEl) {
        var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

        // Fractional views below 992px keep part of the next card in sight so the
        // row always overflows and stays swipeable.
        var breakpoints = {
            0:   { slidesPerView: 1.15, spaceBetween: 12 },
            480: { slidesPerView: 1.6,  spaceBetween: 12 },
            768: { slidesPerView: 2.5,  spaceBetween: 16 },
            992: { slidesPerView: 4,    spaceBetween: 16 }
        };

        if (slideCount < 2) {
            breakpoints = { 0: { slidesPerView: 1, spaceBetween: 0 } };
        }

        new Swiper(swiperEl, {
            slidesPerView: 4,
            spaceBetween: 16,
            loop: false,
            // a row that already fits (4 or fewer cards) stays static
            watchOverflow: true,
            grabCursor: true,
            allowTouchMove: true,

            breakpoints: breakpoints
        });
    });
});

/**
 * Design-25: route "Home Hero text" excerpt + Show more / Show less (<=1199px viewport).
 */
(function design25HomeHeroExpand() {
    var BREAKPOINT_DESKTOP_MIN = 1200;
    var RESIZE_DEBOUNCE_MS = 150;
    var ARROW_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path fill="currentColor" d="M16.59 8.59009L12 13.1701L7.41 8.59009L6 10.0001L12 16.0001L18 10.0001L16.59 8.59009Z"/></svg>';

    function isDesign25() {
        return document.body && document.body.classList.contains('design-25');
    }

    function splitHeroMarkup(html) {
        var trimmed = String(html || '').trim();
        if (!trimmed) {
            return null;
        }

        var tmp = document.createElement('div');
        tmp.innerHTML = trimmed;
        var ps = tmp.querySelectorAll(':scope > p');

        if (ps.length >= 2) {
            var i;
            var rem = '';
            for (i = 1; i < ps.length; i++) {
                rem += ps[i].outerHTML;
            }
            return { excerpt: ps[0].outerHTML, remainder: rem };
        }

        if (ps.length === 1) {
            var inner = ps[0].innerHTML;
            var partsBr = inner.split(/<\s*br\s*\/?\s*>/i);
            if (partsBr.length >= 2) {
                var firstSeg = partsBr.shift().trim();
                var restSeg = partsBr.join('<br />').trim();
                if (!firstSeg || !restSeg) {
                    return null;
                }
                return {
                    excerpt: '<p>' + firstSeg + '</p>',
                    remainder: '<p>' + restSeg + '</p>'
                };
            }
        }

        var topSplit = trimmed.split(/<\s*br\s*\/?\s*>/i);
        if (topSplit.length >= 2) {
            var fst = topSplit.shift().trim();
            var rst = topSplit.join('<br />').trim();
            if (!fst || !rst) {
                return null;
            }
            if (/^<[a-z]/i.test(fst)) {
                return { excerpt: fst, remainder: rst };
            }
            return { excerpt: '<p>' + fst + '</p>', remainder: rst };
        }

        return null;
    }

    function teardownHeroContent(container) {
        if (!container.dataset.design25HeroOriginal) {
            return;
        }
        container.innerHTML = container.dataset.design25HeroOriginal;
        container.classList.remove('design-25-hero-enhanced');
        delete container.dataset.design25HeroOriginal;
    }

    function isEnhancedLayoutValid(container) {
        if (!container.classList.contains('design-25-hero-enhanced')) {
            return true;
        }
        var excerpt = container.querySelector(':scope > .design-25-hero-excerpt');
        var more = container.querySelector(':scope > .design-25-hero-more');
        var toggle = container.querySelector(':scope > .design-25-hero-toggle');
        if (!excerpt || !more || !toggle) {
            return false;
        }
        return excerpt.nextElementSibling === more && more.nextElementSibling === toggle;
    }

    function rehealStaleHeroLayout(container) {
        var saved = container.dataset.design25HeroOriginal;
        if (!saved) {
            return;
        }
        container.innerHTML = saved;
        container.classList.remove('design-25-hero-enhanced');
        delete container.dataset.design25HeroOriginal;
        enhanceHeroContent(container);
    }

    function enhanceHeroContent(container) {
        if (!container.dataset.design25HeroOriginal) {
            container.dataset.design25HeroOriginal = container.innerHTML.trim();
        }
        var fragments = splitHeroMarkup(container.dataset.design25HeroOriginal);
        if (!fragments) {
            delete container.dataset.design25HeroOriginal;
            return;
        }

        var moreId = 'design25-hero-more-' + Math.random().toString(36).slice(2, 11);
        container.classList.add('design-25-hero-enhanced');
        container.innerHTML =
            '<div class="design-25-hero-excerpt">' +
            fragments.excerpt +
            '</div>' +
            '<div class="design-25-hero-more" id="' +
            moreId +
            '" aria-hidden="true" role="region">' +
            '<div class="design-25-hero-more-inner">' +
            fragments.remainder +
            '</div>' +
            '</div>' +
            '<button type="button" class="design-25-hero-toggle" aria-expanded="false" aria-controls="' +
            moreId +
            '">' +
            '<span class="design-25-hero-toggle-label design-25-hero-toggle-label--more">Show more</span>' +
            '<span class="design-25-hero-toggle-label design-25-hero-toggle-label--less">Show less</span>' +
            '<span class="design-25-hero-toggle-icon">' +
            ARROW_SVG +
            '</span>' +
            '</button>';

        var toggle = container.querySelector('.design-25-hero-toggle');
        var more = container.querySelector('.design-25-hero-more');
        if (!toggle || !more) {
            return;
        }

        toggle.addEventListener('click', function () {
            var open = toggle.getAttribute('aria-expanded') === 'true';
            var nextOpen = !open;
            toggle.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
            more.classList.toggle('is-open', nextOpen);
            more.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
        });
    }

    function syncAll() {
        if (!isDesign25()) {
            return;
        }
        var cols = document.querySelectorAll('.home-hero-text .hero-text-content');
        if (!cols.length) {
            return;
        }
        var desktop = window.innerWidth >= BREAKPOINT_DESKTOP_MIN;
        cols.forEach(function (container) {
            if (desktop) {
                teardownHeroContent(container);
            } else {
                if (container.classList.contains('design-25-hero-enhanced') && !isEnhancedLayoutValid(container)) {
                    rehealStaleHeroLayout(container);
                    return;
                }
                if (!container.classList.contains('design-25-hero-enhanced')) {
                    enhanceHeroContent(container);
                }
            }
        });
    }

    var resizeTimer;
    window.addEventListener(
        'resize',
        function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(syncAll, RESIZE_DEBOUNCE_MS);
        },
        false
    );

    document.addEventListener('DOMContentLoaded', function () {
        requestAnimationFrame(syncAll);
    });

    /* === About Us d25-route "Show more" mobile toggle ======================= */
    document.addEventListener('DOMContentLoaded', function () {
        if (!isDesign25()) {
            return;
        }
        document.querySelectorAll('.text-blocks-list--d25-route .d25-route-about-toggle').forEach(function (btn) {
            var moreId = btn.getAttribute('aria-controls');
            var more = moreId ? document.getElementById(moreId) : null;
            if (!more) {
                return;
            }
            btn.addEventListener('click', function () {
                var open = btn.getAttribute('aria-expanded') === 'true';
                var nextOpen = !open;
                btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
                more.classList.toggle('is-open', nextOpen);
                more.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
            });
        });
    });

    /* === Shared d25 "Show more" mobile toggle (resort blocks) ============== */
    document.addEventListener('DOMContentLoaded', function () {
        if (!isDesign25()) {
            return;
        }
        document.querySelectorAll('.d25-more-toggle').forEach(function (btn) {
            var moreId = btn.getAttribute('aria-controls');
            var more = moreId ? document.getElementById(moreId) : null;
            // The state class goes on the wrapper so one click both unclamps the
            // excerpt and expands the collapsed paragraphs.
            var wrap = btn.closest('.d25-more');
            if (!more || !wrap) {
                return;
            }
            btn.addEventListener('click', function () {
                var open = btn.getAttribute('aria-expanded') === 'true';
                var nextOpen = !open;
                btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
                wrap.classList.toggle('is-open', nextOpen);
                more.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
            });
        });
    });

    /* === Map with info items d25 "Show more" mobile toggle ================== */
    document.addEventListener('DOMContentLoaded', function () {
        if (!isDesign25()) {
            return;
        }
        document.querySelectorAll('.get-to-know.d25 .d25-gtk-text-toggle').forEach(function (btn) {
            var moreId = btn.getAttribute('aria-controls');
            var more = moreId ? document.getElementById(moreId) : null;
            // The state class goes on the wrapper so one click both unclamps the
            // excerpt and expands the hidden paragraphs.
            var wrap = btn.closest('.d25-gtk-text');
            if (!more || !wrap) {
                return;
            }
            btn.addEventListener('click', function () {
                var open = btn.getAttribute('aria-expanded') === 'true';
                var nextOpen = !open;
                btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
                wrap.classList.toggle('is-open', nextOpen);
                more.setAttribute('aria-hidden', nextOpen ? 'false' : 'true');
            });
        });
    });

    /* === Resorts by country d25 "Show more" mobile toggle ================== */
    document.addEventListener('DOMContentLoaded', function () {
        if (!isDesign25()) {
            return;
        }
        document.querySelectorAll('.map-list .d25-resorts-toggle').forEach(function (btn) {
            var wrap = btn.closest('.d25-resorts-more');
            if (!wrap) {
                return;
            }
            // No aria-hidden here: the collapsed rows are display:none, so they
            // are already out of the accessibility tree.
            btn.addEventListener('click', function () {
                var nextOpen = btn.getAttribute('aria-expanded') !== 'true';
                btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
                wrap.classList.toggle('is-open', nextOpen);
            });
        });
    });
})();